import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'jrz-common-jrz-common',
  standalone: false,
  template: `
    <p>
      jrz-common works!
    </p>
  `,
  styles: []
})
export class JrzCommonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
